import {
  Component, input, output,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-error-panel',
  standalone: true,
  templateUrl: './error-panel.component.html',
})
export class ErrorPanelComponent {
  message = input.required<string>();
  dismissed = output<void>();

  reload(): void {
    globalThis.location.reload();
  }
}
